<script>
    import interface_element_translations from "./interface_element_translations.json";
    export let user_language;
</script>

<div class="thanks">
    <h3>{interface_element_translations["thankyou_message"][user_language]}</h3>
</div>

<style>
    .thanks {
        margin:25vh auto;
    }
</style>